import dayjs from 'dayjs';

export const dateFormatter = (date, format = "DD.MM.YYYY") => {
    if (!date) return null;
    return dayjs(new Date(date)).format(format);
  };
  